export class DashboardUtils {

    public static DEFAULT_CHART_CONFIG = {
        showXAxis: true,
        showYAxis: true,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
        showYAxisLabel: false,
        colorScheme: { domain: [ "#DED615", "silver" ] },
        yScaleMax: 10
    };

    public static toTagValueLabel(tag : string, unit: string, data : any) {
        if (!data || !data[tag]) {
            return "-";
        }
        return data[tag].value + unit;
    }

    public static toStatusCountLabel(statusTags : any[], label) {
        let totalOn = 0;
        statusTags.forEach(statusTag => {            
            totalOn = totalOn + (statusTag.value == 1 ? 1 : 0);
        });
        return `${totalOn}/${statusTags.length} ${label}`;
    }

    public static dataPointsToSeries(name, dataPoints, seriesByName?) {
        for (let i in dataPoints) {
            var datapoint = dataPoints[i];
            if (!seriesByName[datapoint.name]) {
                seriesByName[datapoint.name] = { order: isNaN(datapoint.name) ? new Date(datapoint.timestamp).getDay() : parseInt(datapoint.name), name: datapoint.name, series: [] };
            }           
            
            seriesByName[datapoint.name].series.push({ "name": name, "value": datapoint.value });
        }
    };

    public static buildDefaultChart(title, tag) {
        return {
            title: title
            , tag: tag
            , config: Object.assign({}, DashboardUtils.DEFAULT_CHART_CONFIG)
            , periodSize: "DAY"
            , periodTargetCurrent: true
            , periodTargetPrevious: false
            // , data: []
        };
    };

    public static updateChart(dataService, chartToUpdate) {
        let windowSize = chartToUpdate.periodSize == "DAY" ? "HOURLY" : "DAILY";
        let timestampPattern = chartToUpdate.periodSize == "DAY" ? "HH" : chartToUpdate.periodSize == "WEEK" ? "ddd" : "dd";

        chartToUpdate.query = { windowSize: windowSize, timestampPattern: timestampPattern, items: [] };
        
        if (chartToUpdate.periodTargetCurrent)  chartToUpdate.query.items.push(DashboardUtils.buildHistoricalQuery(chartToUpdate.periodSize, "CURRENT", chartToUpdate.tag.tagHistoricalValues));
        if (chartToUpdate.periodTargetPrevious) chartToUpdate.query.items.push(DashboardUtils.buildHistoricalQuery(chartToUpdate.periodSize, "PREVIOUS", chartToUpdate.tag.tagHistoricalValues));

        
        if(chartToUpdate.query.items.length == 0) { chartToUpdate.data = []; return; }

        dataService.readHistorical([chartToUpdate.query]).subscribe(chartDataArray => {                
           
            for(let chartIndex in chartDataArray) {
                let chartData = {};
                let chartColors = [];

                let maxYValues = [];
                for(let seriesIndex in chartDataArray[chartIndex].data) {                        
                    let series = chartToUpdate.query.items[seriesIndex];                    
                    maxYValues.push(Math.max(...chartDataArray[chartIndex].data[seriesIndex].values.map(f => f.value)));
                    DashboardUtils.dataPointsToSeries(series.name, chartDataArray[chartIndex].data[seriesIndex].values, chartData);
                    chartColors.push(series.color);
                }

                var seriesArray = [];
                Object.keys(chartData).forEach(key => seriesArray.push(chartData[key]));
                chartToUpdate.data = seriesArray.sort((n1, n2) => n1.order - n2.order);
                chartToUpdate.config.colorScheme = { domain: chartColors };
                // maior valor da escala em Y é maior valor em Y + 10% (para tentar garantir que a biblioteca desenhe o eixo acima do ultimo valor sempre)
                let maxValueInChart = Math.max(...maxYValues);
                chartToUpdate.config.yScaleMax = maxValueInChart + (0.1 * maxValueInChart);
            }
        });
    };

    public static buildHistoricalQuery(periodSize, periodTarget, tag) {
        let name = "-";
        let color = "#DED615";
        let from = new Date();
        let to = new Date();

        let periodType = periodSize + "_" + periodTarget;

        // dia atual
        if (periodType == "DAY_CURRENT") {
            name = "Dia Atual";
            from.setHours(0, 0, 0, 0);
            to.setHours(23, 59, 59, 999);
        }

        // dia anterior
        if (periodType == "DAY_PREVIOUS") {
            name = "Dia Anterior";
            color = "silver";
            from.setDate(from.getDate() - 1);
            from.setHours(0, 0, 0, 0);
            to.setDate(to.getDate() - 1);
            to.setHours(23, 59, 59, 999);
        }

        // semana atual
        if (periodType == "WEEK_CURRENT") {
            name = "Semana Atual";
            from.setHours(0, 0, 0, 0);
            from.setDate(from.getDate() - from.getDay() + (from.getDay() == 0 ? -6 : 1));
            from.setDate(from.getDate() - 1);

            to.setDate(from.getDate() + 7);
        }

        // semana anterior
        if (periodType == "WEEK_PREVIOUS") {
            name = "Semana Anterior";
            color = "silver";

            from.setHours(0, 0, 0, 0);
            from.setDate(from.getDate() - from.getDay() + (from.getDay() == 0 ? -6 : 1));
            from.setDate(from.getDate() - 8);
            to.setDate(from.getDate() + 6);
            to.setHours(23, 59, 59, 999);
        }

        // mes atual
        if (periodType == "MONTH_CURRENT") {
            name = "Mês Atual";
            from.setFullYear(from.getFullYear(), from.getMonth(), 1);
            from.setHours(0, 0, 0, 0);

            to.setFullYear(to.getFullYear(), to.getMonth() + 1, 1);
            to.setDate(to.getDate() - 1);
            to.setHours(23, 59, 59, 999);
        }

        // mes anterior
        if (periodType == "MONTH_PREVIOUS") {
            name = "Mês Anterior";
            color = "silver";
            from.setFullYear(from.getFullYear(), from.getMonth() - 1, 1);
            from.setHours(0, 0, 0, 0);
            to.setFullYear(to.getFullYear(), to.getMonth(), 1);
            to.setDate(to.getDate() - 1);
            to.setHours(23, 59, 59, 999);
        }

        return { name: name, color: color, from: from, to: to, tag: tag };
    };
}